import api from "../Api";
import { ApiPath } from "../ApiPath";
import { ResponseModel } from "../model/response/ResponseModel";
import { CompanyInfoModel } from "../model/response/CompanyInfoModel";
import { useUserContext } from "../../context/UserContext";
import { LanguageModel } from "../model/response/LanguageModel";
import { OnlineMenuModel } from "../model/response/OnlineMenuResponseModel";
import i18n from "i18next";
const OnlineMenuService = () => {
  const { setCurrentOnlineMenu, setCurrentLanguagesList, setCurrentCompanyInfo, utag, setIsCartActive } =
    useUserContext();
  const subDomain = window.location.href.includes("localhost:")
    ? "demo"
    : window.location.href.replaceAll("https://", "").replaceAll("http://", "").split(".")[0];
  const subDomainParams = new URLSearchParams({
    title: subDomain
  });

  function getOnlineMenuLanguages() {
    const err = { error: true } as ResponseModel<LanguageModel[]>;
    return api()
      .get<ResponseModel<LanguageModel[]>>(`${ApiPath.getOnlineMenuLanguages}?${subDomainParams}`, {})
      .then((value) => {
        if (value.data.statusCode === 1000) {
          setCurrentLanguagesList(value.data.responseModel);
          const isTr = value.data.responseModel.some((x) => x.language === "tr");
          if (isTr) {
            void i18n.changeLanguage("tr");
          } else {
            void i18n.changeLanguage(value.data.responseModel[0].language);
          }
          return value.data;
        } else {
          return err;
        }
      })
      .catch(() => {
        return err;
      });
  }
  function getOnlineMenuCompanyInformation() {
    const err = { error: true } as ResponseModel<CompanyInfoModel>;
    return api()
      .get<ResponseModel<CompanyInfoModel>>(`${ApiPath.getOnlineMenuCompany}?${subDomainParams}&productType=1`)
      .then((value) => {
        if (value.data.statusCode === 1000) {
          setCurrentCompanyInfo(value.data.responseModel);
          return value.data;
        } else {
          return err;
        }
      })
      .catch(() => {
        return err;
      });
  }
  function getOnlineMenu() {
    const err = { error: true } as ResponseModel<OnlineMenuModel>;
    return api()
      .get<ResponseModel<OnlineMenuModel>>(`${ApiPath.getOnlineMenuWeb}?${subDomainParams}`)
      .then((value) => {
        if (value.data.statusCode === 1000) {
          setCurrentOnlineMenu(value.data.responseModel);
          if (!value.data.responseModel.isOrderActivated) {
            setIsCartActive(false);
          }
          return value.data;
        } else {
          return err;
        }
      })
      .catch(() => {
        return err;
      });
  }

  const statisticRequest = async (statisticObj: any) => {
    try {
      const userTag = document.cookie
        .split("; ")
        .find((row) => row.startsWith("_ga_1LW64TGQYZ="))
        ?.split("=")[1];
      statisticObj.iTag = userTag ? userTag.split(".")[2] : undefined;
      statisticObj.sTag = userTag;
      statisticObj.subdomain = subDomain;
      const paramUtag = new URLSearchParams(window.location.search).get("utag");
      statisticObj.uTag = utag === "" ? (paramUtag ? paramUtag : undefined) : utag;
      if (process.env.REACT_APP_ENV === "prod") {
        const response = await api().post(`${ApiPath.setOnlineMenuStatistic}`, {
          requestModel: statisticObj
        });
        if (response.status !== 200) {
          throw new Error("Network response was not ok.");
        }
        const data = response.data;
        if (data.statusCode === 1000) {
          //
        } else {
          // eslint-disable-next-line no-console
          console.error("Invalid response status code:", data.statusCode);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error fetching company menu:", error);
    }
  };

  return {
    getOnlineMenu,
    getOnlineMenuCompanyInformation,
    getOnlineMenuLanguages,
    statisticRequest
  };
};
export default OnlineMenuService;

export const StatisticIdentifiers = {
  ONLINE_MENU_PAGE_VIEW: 1,
  CATEGORY_DETAIL_VIEW: 10,
  FOOD_DETAIL_VIEW: 20,
  SEARCH_DETAIL: 30
};
